import React from 'react'

export const RecentActorsIcon = (
  color = '#030405',
  width = 22,
  height = 14
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 14"
      fill="none"
    >
      <path
        d="M2 14C1.45 14 0.979167 13.8042 0.5875 13.4125C0.195833 13.0208 0 12.55 0 12V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14H2ZM2 10.35C2.73333 9.91667 3.51667 9.58333 4.35 9.35C5.18333 9.11667 6.06667 9 7 9C7.93333 9 8.81667 9.11667 9.65 9.35C10.4833 9.58333 11.2667 9.91667 12 10.35V2H2V10.35ZM7 11C6.31667 11 5.65 11.0833 5 11.25C4.35 11.4167 3.73333 11.6667 3.15 12H10.85C10.2667 11.6667 9.65 11.4167 9 11.25C8.35 11.0833 7.68333 11 7 11ZM7 8.25C6.25 8.25 5.60417 7.97917 5.0625 7.4375C4.52083 6.89583 4.25 6.25 4.25 5.5C4.25 4.75 4.52083 4.10417 5.0625 3.5625C5.60417 3.02083 6.25 2.75 7 2.75C7.75 2.75 8.39583 3.02083 8.9375 3.5625C9.47917 4.10417 9.75 4.75 9.75 5.5C9.75 6.25 9.47917 6.89583 8.9375 7.4375C8.39583 7.97917 7.75 8.25 7 8.25ZM7 6.4C7.25 6.4 7.4625 6.3125 7.6375 6.1375C7.8125 5.9625 7.9 5.75 7.9 5.5C7.9 5.25 7.8125 5.0375 7.6375 4.8625C7.4625 4.6875 7.25 4.6 7 4.6C6.75 4.6 6.5375 4.6875 6.3625 4.8625C6.1875 5.0375 6.1 5.25 6.1 5.5C6.1 5.75 6.1875 5.9625 6.3625 6.1375C6.5375 6.3125 6.75 6.4 7 6.4ZM16 14V0H18V14H16ZM20 14V0H22V14H20Z"
        fill={color}
      />
    </svg>
  )
}
